
import React from 'react';
import { supabase } from '@/services/supabase/supabase';
import { toast } from '@/hooks/use-toast';
import { ToastAction } from '@/components/ui/toast';

export const signIn = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
    return data;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to sign in');
  }
};

export const signOut = async (): Promise<void> => {
  try {
    await supabase.auth.signOut();
    
    toast({
      title: 'Signed Out',
      description: 'You have been successfully signed out.',
      action: (
        <ToastAction altText="Sign In" onClick={() => window.location.href = '/login'}>
          Sign In
        </ToastAction>
      )
    });
    
    window.location.href = '/login';
  } catch (error) {
    console.error('Error signing out:', error);
    
    toast({
      title: 'Error',
      description: 'Failed to sign out. Please try again.',
      variant: 'destructive',
    });
  }
};

export const signUp = async (email: string, password: string, fullName: string, toastFn: any) => {
  try {
    const { data, error } = await supabase.auth.signUp({ 
      email, 
      password,
      options: {
        data: {
          full_name: fullName,
        }
      }
    });
    
    if (error) throw error;
    
    toastFn({
      title: 'Account Created',
      description: 'Your account has been created successfully.',
    });
    
    return data;
  } catch (error: any) {
    throw new Error(error.message || 'Failed to create account');
  }
};

export const fetchUserProfile = async (userId: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
    
    const isFirstLogin = !data;
    return isFirstLogin;
  } catch (error) {
    console.error('Error in fetchUserProfile:', error);
    return true; // Default to first login on error
  }
};

export const clearAuthData = () => {
  localStorage.removeItem('auth:token');
  localStorage.removeItem('auth:user');
};
